import ControlGroup from '@amzn/meridian/control-group';
import { localize } from './localize';

export default localize(ControlGroup, ['label']);
